export const userKeys = {
  all: ['user'] as const,
};

export const authKeys = {
  all: ['auth'] as const,
  authenticated: () => [...authKeys.all, 'authenticated'] as const,
  signOut: () => [...authKeys.all, 'signOut'] as const,
};
